<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom">
        <div style="font-weight: 600; font-size: 13px; margin-bottom: 10px">
          基本信息
        </div>
        <div class="info-form">
          <el-form-item label="状态">
            <el-switch
              v-model="state.model.status"
              inline-prompt
              active-text="正常"
              active-color="#1e90ff"
              inactive-text="停用"
              inactive-color="#f00"
              :active-value="1"
              :inactive-value="0"
              style="--el-switch-off-color: #f00"
            />
          </el-form-item>
          <el-form-item
            label="企业名称"
            prop="name"
            :rules="[
              {
                required: true,
                message: '请填写企业名称',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item
            label="统一社会信用代码"
            prop="unified_social_credit_identifier"
            :rules="[
              {
                required: true,
                message: '请填写统一社会信用代码',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="state.model.unified_social_credit_identifier"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所属行业"
            prop="d_industry_id"
            :rules="[
              { required: true, message: '请选择行业', trigger: 'blur' },
            ]"
          >
            <el-tree-select
              v-model="state.model.d_industry_id"
              :data="state.industryData"
              node-key="id"
              clearable
              accordion
              :props="{ label: 'name' }"
              :render-after-expand="false"
              :highlight-current="true"
              :default-expand-all="true"
              :check-strictly="true"
              placeholder="--所属行业--"
              @clear="delete state.model.d_industry_id"
              filterable
            >
              <template #default="{ data }">
                <div style="display: flex; align-items: center">
                  {{ data.name }}
                </div>
              </template>
              <template #footer>
                <el-button size="small" @click="onLoadIndustry()"
                  >刷新</el-button
                >
              </template>
            </el-tree-select>
          </el-form-item>
          <el-form-item label="所属地区">
            <el-cascader
              v-model="state.area"
              :options="state.areaData"
              :props="{ label: 'name', value: 'name' }"
              placeholder="--所属地区--"
              style="width: 100%"
              clearable
              filterable
          /></el-form-item>
          <el-form-item label="所在地址">
            <el-input v-model="state.model.address"></el-input>
          </el-form-item>
        </div>
        <div style="font-weight: 600; font-size: 13px; margin: 10px 0">
          银行账户
        </div>
        <div class="info-form">
          <el-form-item
            label="户名"
            prop="bank_account_name"
            :rules="[
              {
                required: true,
                message: '请填写开户户名',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.bank_account_name"></el-input>
          </el-form-item>
          <el-form-item
            label="开户行"
            prop="opening_bank"
            :rules="[
              {
                required: true,
                message: '请填写开户行',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.opening_bank"></el-input>
          </el-form-item>
          <el-form-item
            label="账号"
            prop="bank_account"
            :rules="[
              {
                required: true,
                message: '请填写银行账号',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.bank_account"></el-input>
          </el-form-item>
          <el-form-item label="是否对接银企">
            <el-switch
              v-model="state.model.is_interface"
              inline-prompt
              active-text="是"
              active-color="#1e90ff"
              inactive-text="否"
              inactive-color="#f00"
              :active-value="1"
              :inactive-value="0"
              style="--el-switch-off-color: #f00"
            />
          </el-form-item>
        </div>
        <div style="font-weight: 600; font-size: 13px; margin: 10px 0">
          报税信息<text style="color: #a2a2a2; font-weight: 500">
            (申报密码和实名登录信息仅需填写一项即可)
          </text>
        </div>
        <div class="info-form">
          <el-form-item
            label="申报密码"
            prop="declare_password"
            :rules="[
              {
                required:
                  !state.model.declare_password &&
                  !state.model.realname_account,
                message: '申报密码合实名密码必须填一项',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              type="password"
              v-model="state.model.declare_password"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="实名登录账号"
            prop="realname_account"
            :rules="[
              {
                required:
                  !state.model.declare_password &&
                  !state.model.realname_password,
                message: '请填写实名登录账号',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.realname_account"></el-input>
          </el-form-item>
          <el-form-item
            label="实名登录密码"
            prop="realname_password"
            :rules="[
              {
                required: state.model.realname_account,
                message: '请填写实名登录密码',
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              type="password"
              show-password
              v-model="state.model.realname_password"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  withholdingagent_add,
  withholdingagent_detail,
  withholdingagent_edit,
} from "@/http/withholdingagent";
import { data_areacode_tree } from "@/http/data";
import { industry_tree } from "@/http/dictionary";
import { post_response } from "@/utils/qFormat";
import { ElMessage } from "element-plus";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        sex: 0,
        property: 0,
        is_interface: 0,
      },
    });
    onMounted(() => {
      onLoadIndustry();
      onLoadAreaCode();

      if (props.id) {
        withholdingagent_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;

            state.area = [state.model.province, state.model.city];
          }
        });
      }
    });

    //获取行业树
    const onLoadIndustry = () => {
      industry_tree().then((res) => {
        if (res.status == 200) state.industryData = res.data.data;
      });
    };

    const onLoadAreaCode = () => {
      data_areacode_tree(2).then((res) => {
        if (res.status == 200) state.areaData = res.data.data?.list;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid, rules) => {
        if (valid) {
          if (state.area?.length == 2) {
            state.model.province = state.area[0];
            state.model.city = state.area[1];
          }

          if (props.id) {
            withholdingagent_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            withholdingagent_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        } else {
          ElMessage({
            type: "warning",
            grouping: true,
            message: rules[Object.keys(rules)[0]][0]?.message,
          });
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onLoadIndustry,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less"></style>
